import { useState, useEffect } from "react";
import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table/interface";
import { ISearchPage } from "@/types/ScmTypes";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, } from "@/utils/constants";
import { saleDcService } from "./saleDcService";
import useGlobalModel from "@/model/globalModel";
import { ISCMSaleDcSearchFields, ISCMSaleDcDetail, ISCMSaleDcStatistics } from "./saleDcTypes";
import { convertRes2Blob } from "@/utils/exportFile";
import { transPgToPagination } from "@/utils/utils";
import { isArray } from "util";


export const useSaleDcModel = createModel(function () {
    const { user: { shopId, shopCode }, shopAndOrg: { shopType }, shopAndOrg, setLoadingInfo } = useGlobalModel();
    //查询条件
    const [searchParam, setSearchParam] = useState<ISCMSaleDcSearchFields>({});
    //列表数据源
    const [dataSource, setDataSource] = useState<ISCMSaleDcDetail[]>([]);
    //表格选中行Key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
    //列表数据源分页参数
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    //列表统计展示数据
    const initStatistics = {
        // aggregateAmount: "0.00",
        // paidAmount: "0.00",
        totalAmount: "0.00",
        totalNum: 0
    };
    const [statistics, setStatistics] = useState<ISCMSaleDcStatistics>(initStatistics);
    const [loading, setLoading] = useState<boolean>(false);

    const updateSearchParam = (updateParam: ISCMSaleDcSearchFields) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }

    //切换站点重置缓存
    useEffect(() => {
        setSearchParam({});
        setSelectedRowKeys([]);
    }, [shopId]);

    //重置
    const resetSearchParam = () => {
        setSearchParam({});
        setSelectedRowKeys([]);
        loadData(initPgCfg, {});
    }

    const loadData = async (page?: ISearchPage, searchValue: ISCMSaleDcSearchFields = searchParam) => {
        setLoading(true);
        const shopParam = {
            outShopType: searchValue.outShopId !== undefined ? 1 : shopType,
            outShopId: searchValue?.outShopId ?? shopAndOrg.shopId,
            // shopType: searchValue.shopId !== undefined ? 1 : null,
            // shopId: searchValue.shopId,
        };
        const searchParams = {
            ...searchValue,
            ...shopParam,
            status: isArray(searchValue?.status) ? searchValue?.status.join() : searchValue?.status,
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        let { retData } = await saleDcService.page(searchParams);
        const { records, ...pg } = retData;
        setPgCfg(transPgToPagination(pg));
        setDataSource(records);
        setLoading(false);
        loadTotal(searchParams);

    }
    const loadTotal = async (searchParams: any) => {
        let { retData: statistics } = await saleDcService.pageStatistics(searchParams);
        setStatistics(statistics ?? initStatistics);
    }

    //导出
    const exportSaleDc = async (searchValue: ISCMSaleDcSearchFields = searchParam) => {
        setLoadingInfo({ loadingVisible: true, txt: "快速导出中" });
        try {
            const shopParam = {
                outShopType: searchValue.outShopId !== undefined ? 1 : shopType,
                outShopId: searchValue?.outShopId ?? shopAndOrg.shopId,
                // shopType: searchValue.shopId !== undefined ? 1 : null,
                // shopId: searchValue.shopId,
            };
            const searchParams = {
                inAndOut: "1",
                ...searchValue,
                ...shopParam,
                status: isArray(searchValue?.status) ? searchValue?.status.join() : searchValue?.status,
                pageSize: -1,
                pageNum: 1,
            }
            let result = await saleDcService.export(searchParams);
            result && setLoadingInfo({ loadingVisible: false, txt: "" });
            convertRes2Blob(result);
        } catch { setLoadingInfo({ loadingVisible: false, txt: "" }) }
    }
    const exportStatisticsExport = async (searchValue: ISCMSaleDcSearchFields = searchParam) => {
        setLoadingInfo({ loadingVisible: true, txt: "快速导出中" });
        try {
            const shopParam = {
                outShopType: searchValue.outShopId !== undefined ? 1 : shopType,
                outShopId: searchValue?.outShopId ?? shopAndOrg.shopId,
                // shopType: searchValue.shopId !== undefined ? 1 : null,
                // shopId: searchValue.shopId,
            };
            const searchParams = {
                inAndOut: "1",
                ...searchValue,
                ...shopParam,
                status: isArray(searchValue?.status) ? searchValue?.status.join() : searchValue?.status,
                pageSize: -1,
                pageNum: 1,
            }
            let result = await saleDcService.statisticsExport(searchParams);
            result && setLoadingInfo({ loadingVisible: false, txt: "" });
            convertRes2Blob(result);
        } catch { setLoadingInfo({ loadingVisible: false, txt: "" }) }
    }
    return {
        /***field***/
        searchParam,
        dataSource,
        selectedRowKeys,
        pgCfg,
        statistics,
        loading,
        /***method***/
        setDataSource,
        setSelectedRowKeys,
        resetSearchParam,
        updateSearchParam,
        loadData,
        exportSaleDc,
        exportStatisticsExport

    }
});